// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mj-2";
export var interactiveWrapper = "_mj-0";
export var shippingHoverPreview = "_mj-4";
export var summaryBadgeTrigger = "_mj-1";
export var widgetHoverPreviewList = "_mj-3";
export var widgetPreviewScale = "_mj-5";